import moment from "moment";

export class LoadBookingsOfCurrentDay {
	static readonly type = "[Booking] Load Bookings Of Current Day";
}

export class RecalculateRoomAvailabilityStatus {
	static readonly type = "[Booking] Recalculate current room availability status";
}

export class CheckinBooking {
	static readonly type = "[Booking] Checkin";
}

export class CheckoutBooking {
	static readonly type = "[Booking] Checkout";
}

export class LoadBookingsForDay {
	static readonly type = "[Booking] Load Bookings for specific day";
	constructor(public day: moment.Moment) {}
}
